import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "@/lib/useApi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Save, Send } from "lucide-react";

const empty = { host: "", port: 587, username: "", password: "", from_email: "", from_name: "GoWeb Reseller", use_ssl: false };

export default function AdminSmtp() {
  const api = useApi();
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ["admin-smtp"],
    queryFn: async () => (await api.get("/admin/smtp")).data,
  });
  const [form, setForm] = useState(empty);
  const [testTo, setTestTo] = useState("");

  useEffect(() => { if (data && Object.keys(data).length) setForm({ ...empty, ...data }); }, [data]);

  const save = useMutation({
    mutationFn: async () => (await api.put("/admin/smtp", form)).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["admin-smtp"] }); toast.success("Salvato"); },
  });
  const test = useMutation({
    mutationFn: async () => (await api.post("/admin/smtp/test", { to: testTo })).data,
    onSuccess: (r) => r.sent ? toast.success("Email di test inviata") : toast.error(`Invio fallito: ${r.reason}`),
  });

  return (
    <div className="space-y-4 max-w-3xl">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Configurazione SMTP</h1>
        <p className="text-sm text-slate-500 mt-1">Server utilizzato per inviare le email del portale (anagrafiche, approvazioni, credenziali clienti).</p>
      </div>
      <div className="bg-white border border-[#E2DDD5] rounded-xl p-5 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><Label>Host</Label><Input value={form.host} onChange={(e) => setForm({ ...form, host: e.target.value })} placeholder="smtp.esempio.it" data-testid="smtp-host" /></div>
          <div><Label>Porta</Label><Input type="number" value={form.port} onChange={(e) => setForm({ ...form, port: Number(e.target.value) })} data-testid="smtp-port" /></div>
          <div><Label>Username</Label><Input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} data-testid="smtp-username" /></div>
          <div><Label>Password</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="smtp-password" /></div>
          <div><Label>Email mittente</Label><Input value={form.from_email} onChange={(e) => setForm({ ...form, from_email: e.target.value })} placeholder="noreply@goweb.srl" data-testid="smtp-from-email" /></div>
          <div><Label>Nome mittente</Label><Input value={form.from_name} onChange={(e) => setForm({ ...form, from_name: e.target.value })} data-testid="smtp-from-name" /></div>
          <div className="flex items-center gap-2 pt-6"><Switch checked={form.use_ssl} onCheckedChange={(v) => setForm({ ...form, use_ssl: v })} data-testid="smtp-ssl" /><Label>SSL/TLS implicito (porta 465)</Label></div>
        </div>
        <Button onClick={() => save.mutate()} className="bg-[#B84A2B] hover:bg-[#983C21] text-white" data-testid="btn-save-smtp"><Save size={14} className="mr-1" /> Salva</Button>
      </div>

      <div className="bg-white border border-[#E2DDD5] rounded-xl p-5">
        <div className="font-semibold mb-2">Test di invio</div>
        <div className="flex items-end gap-2">
          <div className="flex-1"><Label>Destinatario</Label><Input value={testTo} onChange={(e) => setTestTo(e.target.value)} placeholder="tu@dominio.it" data-testid="smtp-test-to" /></div>
          <Button onClick={() => test.mutate()} disabled={!testTo} className="bg-[#1E2A38] text-white hover:bg-[#0F141A]" data-testid="btn-smtp-test"><Send size={14} className="mr-1" /> Invia test</Button>
        </div>
      </div>
    </div>
  );
}
